import type { MatchUnitProps } from '@shared/MatchUnit';
import type { Enum } from '@shared-types/enum.types';
import type { RoundPhase } from '@shared-types/match.types';

export const SlotType = {
  MATCH: 'MATCH',
  MATCHDAY: 'MATCHDAY',
  DRAW: 'DRAW',
  PLACEHOLDER: 'PLACEHOLDER',
} as const;
export type SlotType = Enum<typeof SlotType>;

export type Slot = {
  id: string;
  matchIds?: string[];
  type: SlotType;
  date: string;
  roundName?: string;
  roundId?: string;
  title: string;
  competition: {
    id: string;
    displayName: string;
    qualifyingName: string;
    prequalifyingName: string;
    compCode: string;
    phase: RoundPhase;
    cupFolder: string;
  };
};

export type FootballRailOptions = MatchUnitProps['options'] & {
  interval: number;
  libraryUrl: string;
};
